import React, { useEffect } from "react";
import { useStore } from "../../app/stores/store";
import DataTable, { DataType } from "../../app/common/DataTable";
import { useTranslation } from "react-i18next";

export default function MembershipPaymentsByYear() {
    const { t } = useTranslation();
    const memberStore = useStore((s) => s.memberStore);
    const selectedMemberId = memberStore.selectedMember?.id;

    useEffect(() => {
        if (selectedMemberId) {
            memberStore.loadMembershipPaymentsByYear(selectedMemberId);
        }
    }, [selectedMemberId]);

    const columns = [
        { key: "year", header: t("general.year"), dataType: DataType.NUMBER },
        { key: "membershipFee", header: t("unpaidMemberships.columns.membershipFee"), dataType: DataType.NUMBER, formatPrice: true },
        { key: "totalPaid", header: t("unpaidMemberships.columns.totalPaid"), dataType: DataType.NUMBER, formatPrice: true },
        { key: "totalDebt", header: t("unpaidMemberships.columns.totalDebt"), dataType: DataType.NUMBER, formatPrice: true },
    ];

    return (
        <DataTable
            columns={columns}
            data={memberStore.membershipPaymentsByYear}
            disableRowClick
        />
    );
}